import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import IziLifePayNav from "./modules/izilife-pay/IziLifePayNav";
import SuperAdminDashboard from "./pages/admin/SuperAdminDashboard";
import UnsubscribePage from "./pages/UnsubscribePage";
import SEO from "./components/common/ui/SEO";
import { initCustomAlerts } from "./modules/izilife-pay/helpers/alertError";
import DeniedPage from "./pages/auth/DeniedPage";
import ProtectedRoute from "./wrappers/ProtectedRoutes";

function App() {
  // Initialiser le remplacement des alerts
  initCustomAlerts();
  return (
    <>
      <SEO
        title="Kafintech Group | Dashboard Admin"
        favicon="/favicon.ico"
        description="Kafintech Group : applications fintech pour la gestion et le transfert d’argent, avec IZILIFE-PAY et EasyLife Market."
      />
      <Routes>
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/unsubscribe" element={<UnsubscribePage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={["ADMIN"]}>
              <SuperAdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/izilife-pay/*"
          element={
            <ProtectedRoute allowedRoles={["ADMIN"]}>
              <IziLifePayNav />
            </ProtectedRoute>
          }
        />
        <Route path="/denied/*" element={<DeniedPage />} />
      </Routes>
    </>
  );
}

export default App;
